import React, { forwardRef } from "react";

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
  className?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  validateBeforeSubmit?: boolean;
}

const Form = forwardRef<HTMLFormElement, FormProps>(({
  children,
  className = "",
  onSubmit,
  validateBeforeSubmit = true,
  ...props
}, ref) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    console.log("🔍 [Form] handleSubmit triggered", {
      type: e.type,
      target: e.target,
      currentTarget: e.currentTarget,
      onSubmitExists: !!onSubmit,
      validateBeforeSubmit
    });
    
    e.preventDefault();
    console.log("✅ [Form] Form event prevented");
    
    if (validateBeforeSubmit && e.currentTarget) {
      console.log("🔍 [Form] Checking form validity...");
      const isValid = e.currentTarget.checkValidity();
      console.log("🔍 [Form] Form validity result:", isValid);
      
      if (!isValid) {
        console.log("❌ [Form] Form validation failed, calling reportValidity");
        e.currentTarget.reportValidity();
        return;
      }
      console.log("✅ [Form] Form validation passed");
    } else {
      console.log("🔍 [Form] Skipping form validation (validateBeforeSubmit:", validateBeforeSubmit, ")");
    }
    
    if (onSubmit) {
      console.log("✅ [Form] Calling onSubmit handler...");
      try {
        onSubmit(e);
        console.log("✅ [Form] onSubmit handler completed successfully");
      } catch (error) {
        console.error("❌ [Form] Error in onSubmit handler:", error);
      }
    } else {
      console.log("❌ [Form] No onSubmit handler provided");
    }
  };

  console.log("🔍 [Form] Form component rendering with onSubmit:", !!onSubmit);

  return (
    <form className={className} onSubmit={handleSubmit} ref={ref} {...props} noValidate={false}>
      {children}
    </form>
  );
});

Form.displayName = "Form";

export default Form; 